const p = 0, n = 10, m = [
  "m",
  "mt",
  "mr",
  "mb",
  "ml",
  "p",
  "pt",
  "pr",
  "pb",
  "pl"
];
export {
  n as maxSpacingValue,
  p as minSpacingValue,
  m as spacingOptionsKeys
};
//# sourceMappingURL=spacing.js.map
